export { default } from './PageCategory.vue'
